import PropTypes from 'prop-types';
import './Buttons.css';

/**
 * Button Component
 * 
 * Props:
 * - `variant`: Defines the button style (e.g., primary, secondary, danger, success, outline, ghost).
 * - `size`: Defines the button size (e.g., small, medium, large).
 * - `disabled`: Disables the button when true.
 * - `onClick`: Function triggered when the button is clicked.
 * - `children`: Button label or content.
 */

const Button = ({ variant='primary', height='', size='medium', background, disabled, onClick, children, className }) => {
    const buttonClass = `${className ? className :''} btn btn-${variant} ${background ? `btn-${background}` : ''} btn-${size} ${disabled ? 'btn-disabled' : ''}`;

    return (
        <button
            className={buttonClass}
            onClick={onClick}
            disabled={disabled}
        >
            {children || (variant === 'close' ? '' : 'Button')}
        </button>
    );
};

// Define prop types
Button.propTypes = {
    variant: PropTypes.oneOf(['primary','secondary','danger','popup','close','ghost']),
    size: PropTypes.oneOf(['small','medium','large','round','xlarge']),
    background: PropTypes.oneOf(['color1','color2','color3']),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.node,
  };

export default Button;